import React from 'react';

import styles from './not-found.module.scss';

const NotFound = () => (
  <h1 className={styles.container}>Not found</h1>
)

export default NotFound;